<template>
  <v-app id="inspire">
    <!--div>
  <b-navbar toggleable="lg" type="dark" variant="info">
    <b-navbar-brand href="#">NavBar</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item href="#">Link</b-nav-item>
        <b-nav-item href="#" disabled>Disabled</b-nav-item>
      </b-navbar-nav>

      //Right aligned nav items 
      <b-navbar-nav class="ml-auto">
        <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form>

        <b-nav-item-dropdown text="Lang" right>
          <b-dropdown-item href="#">EN</b-dropdown-item>
          <b-dropdown-item href="#">ES</b-dropdown-item>
          <b-dropdown-item href="#">RU</b-dropdown-item>
          <b-dropdown-item href="#">FA</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown right>
          //Using 'button-content' slot 
          <template #button-content>
            <em>User</em>
          </template>
          <b-dropdown-item href="#">Profile</b-dropdown-item>
          <b-dropdown-item href="#">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div-->
    <v-navigation-drawer app :mini-variant.sync="mini" mini-variant-width="90">
      <v-list-item>
        <v-list-item-content>
          <h5 class="mb-2" v-if="!mini">Borderless Lab 365</h5>
          <v-list-item-title class="title">
            <p>
              {{ labelExperiment($route.params.experiment_name) }}
              <v-btn icon @click.stop="mini = !mini">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </p>
          </v-list-item-title>
          <v-list-item-subtitle v-if="$route.name == 'experiment'">
            Room {{ parseInt($cookies.get("equipment_id").slice(-1)) + 1 }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list dense nav>
        <v-list-item
          link
          @click="openManual"
          v-if="$route.name == 'experiment' || $route.name == 'board'"
        >
          <v-list-item-content>
            <v-list-item-title>Lab Manual</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          @click="setupDialog = true"
          v-if="$route.name == 'experiment' || $route.name == 'board'"
        >
          <v-list-item-content>
            <v-list-item-title>Equipment Setup</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$route.name == 'experiment'">
          <v-list-item-content>
            <v-list-item-title>
              <v-btn dark :block="!mini" color="info" class="mt-4">
                <v-icon small class="mr-2">mdi-clock</v-icon>
                {{ Math.ceil(parseInt(kick_time) / 60) }}
                <span v-if="!mini">mins left</span>
              </v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-btn
        x-small
        class="ml-4 my-4"
        dark
        color="info"
        @click="feedbackDialog = true; syncFeedback();"
        >Feedback</v-btn
      >
      <v-btn
        v-if="$cookies.isKey('username')"
        x-small
        class="ml-4 my-4"
        dark
        color="error"
        @click="goTo('/logout')"
      >
        Logout
      </v-btn>
      <v-btn v-else x-small class="ml-4 my-4" @click="goTo('/login')"
        >Login</v-btn
      >
      <br />
      <small class="ma-4">230126.6.2</small>
      
    </v-navigation-drawer>

    <v-content>
      <router-view class="mx-4" @kickTime="updateKickTime"/>
    </v-content>

    <!-- Setup Dialog -->
    <v-dialog
      v-model="setupDialog"
      width="600"
      persistent
      v-if="$route.name == 'experiment' || $route.name == 'board'"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2"> Setup </v-card-title>
        <v-card-text>
          <v-img
            :src="
              $store.state.experiments[$route.params.experiment_name].setupPhoto
            "
            fluid
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="setupDialog = false"> Hide</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Feedback Dialog -->
    <v-dialog v-model="feedbackDialog" width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2"> Feedback </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                label="Login name"
                v-model="feedbackUser"
                :readonly="logged == true"
              >
              </v-text-field>
            </v-col>
            <v-col>
              
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                label="Email address"
                v-model="feedbackEmail"
                dense
              >
              </v-text-field>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
              :items="experiments"
              item-text="text"
              item-value="value"
              v-model="feedbackExperiment"
              label="Experiment"
              dense
              ></v-select>
            </v-col>
            <v-col>
                <v-select
                :items="equipment_ids"
                item-text="text"
                item-value="value"
                v-model="feedbackEquipment"
                label="Room"
                dense
                ></v-select>
            </v-col>
          </v-row>
          <p class="mt-4">What kind of problem faced?</p>
          <v-radio-group v-model="feedbackCategory" column>
            <v-radio
              label="Cannot book experiment"
              value="cannot_book_experiment"
            ></v-radio>
            <v-radio
              label="Cannot enter experiment"
              value="cannot_enter_experiment"
            ></v-radio>
            <v-radio
              label="Cannot finish experiment"
              value="cannot_finish_experiment"
            ></v-radio>
            <v-radio
              label="Camera no response"
              value="camera_no_response"
            ></v-radio>
            <v-radio label="Others" value="others"></v-radio>
          </v-radio-group>
          <v-textarea
            rows="1"
            auto-grow
            label="Details"
            v-model="feedbackDetails"
            hint="Bug Report or Comments"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="feedbackDialog = false">
            Quit</v-btn
          >
          <v-btn color="success" text @click="submitFeedback">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- snackbar -->
    <v-snackbar v-model="$store.state.snackbar.modal">
      {{ $store.state.snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <div></div>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({    
    msg: "",
    auth_token: "",
    setupDialog: false,
    feedbackDialog: false,
    mini: false,
    kick_time: 0,
    logged: false,
    feedbackCategory: "",
    feedbackDetails: "",
    feedbackEmail: "",
    feedbackUser: "",
    feedbackExperiment: "",
    feedbackEquipment: "",
    experiments:[
        {
            text:"Not applicable",
            value:"null"
        },
        {
            text:"Apparent Depth",
            value:"apparent_Depth"
        },
        {
            text:"Bacteria Growth",
            value:"bacteria_growth"
        },
        {
            text:"EM Induction",
            value:"em_induction"
        },
        {
            text:"Green House",
            value:"green_house"
        },
        {
            text:"Identify Unknown Anion",
            value:"identify_unknown_anion"
        },
        {
            text:"Interference",
            value:"interference"
        },
        {
            text:"Photo Electric",
            value:"photo_electric"
        },
        {
            text:"Photosynthesis",
            value:"photosynthesis"
        },
        {
            text:"Radiation",
            value:"radiation"
        },
        {
            text:"Respiration",
            value:"respiration"
        },
        {
            text:"Titration",
            value:"titration"
        },
        {
            text:"Ultrasound",
            value:"ultrasound"
        },
        {
            text:"Visible Spectrum",
            value:"visible_spectrum"
        },
        {
            text:"Spectrophotometry",
            value:"spectrophotometry"
        },
        {
            text:"IODINE_TEST",
            value:"iodine_test"
        },
        {
            text:"TENSILE_TEST",
            value:"tensile_test"
        },
        {
            text:"New Interference",
            value:"new_interference"
        },
        {
            text:"Capacitance",
            value:"capacitance"
        },
    ],
    equipment_ids:[
        {
            text:"Not applicable",
            value:"null"
        },
        {
            text:"Room 1",
            value:"set_0"
        },
        {
            text:"Room 2",
            value:"set_1"
        },
        {
            text:"Room 3",
            value:"set_2"
        },
        {
            text:"Room 4",
            value:"set_3"
        },
    ],
  }),

  mounted: function () {
  },
  methods: {
    updateKickTime(time) {
        this.kick_time = time;
    },
    labelExperiment: function (name) {
      switch(name){
        case "interference":
            this.experiment = "Interference";
        break;
        case "visible_spectrum":
            this.experiment = "Visible Spectrum";
        break;
        case "apparent_depth":
            this.experiment = "Apparent Depth";
        break;
        case "bacteria_growth":
            this.experiment = "Bacteria Growth";
        break;
        case "em_induction":
            this.experiment = "EM Induction";
        break;
        case "green_house":
            this.experiment = "Green House";
        break;
        case "photo_electric":
            this.experiment = "Photo Electric";
        break;
        case "radiation":
            this.experiment = "Radiation";
        break;
        case "titration":
            this.experiment = "Titration";
        break;
        case "ultrasound":
            this.experiment = "Ultrasound";
        break;
        case "respiration":
            this.experiment = "Respiration";
        break;
        case "photosynthesis":
            this.experiment = "Photosynthesis";
        break;
        case "identify_unknown_anion":
            this.experiment = "Identify Unknown Anion";
        break;
        case "kinetic_rate":
            this.experiment = "Kinetic Rate";
        break;
        case "new_interference":
            this.experiment = "New Interference";
        break;
        case "capacitance":
            this.experiment = "Capacitance";
        break;
      }
    },
    goTo: function (name) {
      var self = this;
      self.$router.push(name);
    },
    changeLang: function (lang) {
      var self = this;
      self.$i18n.locale = lang;
    },
    openManual() {
      window.open(
        this.$store.state.experiments[this.$route.params.experiment_name]
          .labManual
      );
    },
    syncFeedback(){
      var self = this;
      self.feedbackUser = self.$cookies.get("username");
      if(self.feedbackUser == null){
        self.logged = false;
        self.feedbackUser = "";
      }
      else {
        self.logged = true;
        self.feedbackUser = self.$cookies.get("username");
      }
      self.feedbackExperiment = self.$cookies.get("experiment");
      if(self.feedbackExperiment == null){
       self.feedbackExperiment = self.$route.params.experiment_name;
       if(self.feedbackExperiment == null){
         self.feedbackExperiment = null;
       }
      }
      self.feedbackEquipment = self.$cookies.get("equipment_id");
    },
    submitFeedback() {
      var self = this;
      const url =
        "https://hooks.slack.com/services/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";        
      const data = {
        text:
          "User Feedback" +
          "\n" +
          "User: " +
          this.feedbackUser +
          "\n" +
          "Email Address: " +
          this.feedbackEmail +
          "\n" +
          "Experiment: " +
          this.feedbackExperiment +
          "\n" +
          "Set: " +
          this.feedbackEquipment +
          "\n" +
          "feedbackCategory: " +
          this.feedbackCategory +
          "\n" +
          "feedbackDetails: " +
          this.feedbackDetails +
          "\n" +
          "\n",
      };
      this.axios.post(url, JSON.stringify(data), {
        withCredentials: false,
        transformRequest: [
          (data, headers) => {
            delete headers.post["Content-Type"];
            return data;
          },
        ],
      });
      alert("Thank you for your feedback!");
      self.feedbackDialog = false;
    },
  },
};
</script>
<style lang="scss">
.chem-btn {
  text-transform: unset !important;
}
</style>